import React from "react";

interface YoutubeVideoProps {
  videoId: string;
  height?: string;
}

const YoutubeVideo: React.FC<YoutubeVideoProps> = ({
  videoId,
  height = "h-screen",
}) => {
  return (
    <section className={`w-full bg-black ${height}`}>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?start=4`}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
        frameBorder={0}
        className="w-full h-full"
      />
    </section>
  );
};

export default YoutubeVideo;
